import {
    container,
    textContainer,
    imgWrapper,
    reversed,
    moduleContainer,
    imageContainer,
    library,
    quiz,
    cards
} from './screenshot-text.module.scss';

interface Props {
    title: string;
    text: string;
    module: Module;
    image: string;
    altText: string;
    reverse?: boolean;
}

export enum Module {
    LIBRARY = 'LIBRARY',
    CARDS = 'CARDS',
    QUIZ = 'QUIZ'
}

export const ScreenshotAndText = ({
    title,
    text,
    module = Module.LIBRARY,
    image,
    altText,
    reverse = false,
    ...rest
}: Props) => (
    <div className={`${container} ${reverse ? reversed : ''}`}>
        <div className={` ${imageContainer} `}>
            <div className={`${imgWrapper} ${module === Module.QUIZ ? quiz : ''}`}>
                <img src={image} alt={altText} />
            </div>
        </div>
        <div className={textContainer}>
            <div
                className={` ${moduleContainer} ${
                    module === Module.LIBRARY ? library : module === Module.QUIZ ? quiz : cards
                }`}>
                {module}
            </div>
            <h3>{title}</h3>
            <p>{text}</p>
        </div>
    </div>
);
